export default __webpack_public_path__ + "static/media/logo.e03c6f2a.png";